import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/UserAbout/config';
import { ExternalReactRenderers } from '../../../Editor/types';
import cn from 'classnames';
import { Measureable } from '../../types';

import s from './GroupAbout.scss';

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
}

const GroupAboutViewer = React.forwardRef<HTMLDivElement, Props>(
  (
    { contentJson, className, externalRenderers, cookieType, defaultSize },
    ref
  ) => {
    return (
      <Viewer
        presetId="groupabout"
        contentJson={contentJson}
        className={cn(s['root'], className)}
        extensionConfig={extConfig}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
GroupAboutViewer.displayName = 'GroupAboutViewer';

export default GroupAboutViewer;
